import { useRole } from "../../hooks/useRole";
import { EmptyState } from "../Common.jsx";

export default function RequireRole({ role, children }) {
  const current = useRole();
  if (current == null) {
    return (
      <div className="card" style={{ padding: 24, textAlign: "center", color: "var(--text-muted)" }}>
        Loading…
      </div>
    );
  }
  const allowed = Array.isArray(role) ? role.includes(current) : current === role;
  if (!allowed) {
    return (
      <EmptyState
        title="Access denied"
        desc="You don't have permission to view this section."
        icon="shield-off"
      />
    );
  }
  return children;
}
